import { render, staticRenderFns } from "./OurExpandIcon.vue?vue&type=template&id=91f3a11e&"
import script from "./OurExpandIcon.vue?vue&type=script&lang=js&"
export * from "./OurExpandIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports